import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '@/api/client'

// All surfaces use admin-design theme tokens; see Dashboard.tsx for the rule.
export default function Login() {
  const nav = useNavigate()
  const [email, setEmail] = useState('')
  const [pass, setPass] = useState('')
  const [err, setErr] = useState('')
  const [loading, setLoading] = useState(false)

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setErr('')
    setLoading(true)
    try {
      await api.login(email, pass)
      nav('/')
    } catch {
      setErr('로그인 실패 — 이메일/비밀번호를 확인하세요')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen grid place-items-center bg-background text-foreground">
      <form
        onSubmit={onSubmit}
        className="w-80 space-y-3 p-6 border border-border rounded-xl bg-card text-card-foreground shadow-sm"
      >
        <h1 className="text-lg font-semibold">LlmSaas Admin</h1>
        <label className="block text-xs text-muted-foreground">이메일</label>
        <input
          className="w-full px-3 py-2 border border-border rounded bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
          required
        />
        <label className="block text-xs text-muted-foreground">비밀번호</label>
        <input
          className="w-full px-3 py-2 border border-border rounded bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring"
          value={pass}
          onChange={(e) => setPass(e.target.value)}
          type="password"
          required
        />
        {err && <p className="text-sm text-destructive">{err}</p>}
        <button
          className="w-full py-2 bg-primary text-primary-foreground rounded disabled:opacity-50 hover:opacity-90 transition-opacity"
          type="submit"
          disabled={loading}
        >
          {loading ? '...' : 'Login'}
        </button>
      </form>
    </div>
  )
}
